import _ from 'lodash'
import $ from 'jquery'
import Backbone from 'backbone'
import template from './choose-field.hbs'
import FormView from 'scoreboard/components/form-view'
import massEditFields from './mass-edit-fields'
import fieldRow from './choose-field-row.hbs'

/**
 * Dialog for choosing a field for mass editing scorecard items
 */
const ChooseField = Backbone.View.extend({
	tagName: 'form',

	className: 'choose-field',

	events: {
		'click td[data-value]': 'onClickField'
	},

	/**
	 * @param {Object} options
	 * @param {Object} [options.selectedField] currently selected field for
	 * mass editing
	 */
	initialize: function(options = {}) {
		this.options = options
		this.field = this.options.field
		this.formView = new FormView({
			el: this.el,
			submit: this.submit.bind(this),
			allowCleanSubmission: true
		})
		this.availableFields = massEditFields()
		this.selectedField = _.get(this.options, 'selectedField')
	},

	render: function() {
		this.$el.empty().append(template())
		this.renderTables()
		let selectedFieldValue = _.get(this.selectedField, 'value')
		let fieldValues = _.map(this.availableFields, 'value')
		if (!_.isNil(this.selectedField) && _.includes(fieldValues, selectedFieldValue)) {
			this.$(`td[data-value='${selectedFieldValue}']`).addClass('is-selected', true)
		}
		this.formView.start()
		return this
	},

	renderTables() {
		let basicsFields = _.filter(this.availableFields, f => f.group === 'all')
		let kpiOnlyFields = _.filter(this.availableFields, f => f.group === 'kpi-only')
		let basicsLength = _.size(basicsFields)
		let kpiOnlyLength = _.size(kpiOnlyFields)

		for (let i = 0; i < Math.max(basicsLength, kpiOnlyLength); i++) {
			this.$('table tbody').append(fieldRow({
				cells: [basicsFields[i], kpiOnlyFields[i]]
			}))
		}
	},

	onClickField: function(e) {
		let td = this.$(e.currentTarget)
		if (td.hasClass('not-clickable')) {
			return
		}

		// clear previous selection
		_.forEach(this.$('td.field'), td => {
			$(td).removeClass('is-selected')
		})

		$(td).addClass('is-selected')
		this.selectedField = td.data('value')
	},

	submit: function() {
		let field = _.find(this.availableFields, f => {
			return f.value === this.selectedField
		})
		this.trigger('done', field)
	}
})

export default ChooseField
ChooseField.__filename__ = 'admin/mass-edit/choose-field.js'
